import React from 'react';
import OfferImg1 from '../../assets/images/a.png';
import OfferImg2 from '../../assets/images/b.png';
import OfferImg3 from '../../assets/images/c.png';
import OfferImg4 from '../../assets/images/d.png';
export default function Offers() {
  return (
    <div className={'flex flex-col justify-center items-center p-8'}>
      <h3 className={'text-4xl lg:text-5xl'}>
        <span>Our</span>{' '}
        <span className={'font-semibold text-yellow-500 leading-none'}>
          Offerings
        </span>
      </h3>
      <div
        className={'flex flex-row justify-around items-start flex-wrap mt-5'}
      >
        <div
          className={
            'w-1/2 lg:w-1/4 p-4 flex flex-col justify-center items-center'
          }
        >
          <img alt={''} src={OfferImg1} />
          <h3
            className={
              'mt-5 text-gray-800 text-lg lg:text-xl text-center font-normal lg:font-semibold'
            }
          >
            Bulk Disbursement to Save Time
          </h3>
        </div>
        <div
          className={
            'w-1/2 lg:w-1/4 p-4 flex flex-col justify-center items-center'
          }
        >
          <img alt={''} src={OfferImg2} />
          <h3
            className={
              'mt-5 text-gray-800 text-lg lg:text-xl text-center font-normal lg:font-semibold'
            }
          >
            Schedule Reward
          </h3>
        </div>
        <div
          className={
            'w-1/2 lg:w-1/4 p-4 flex flex-col justify-center items-center'
          }
        >
          <img alt={''} src={OfferImg3} />
          <h3
            className={
              'mt-5 text-gray-800 text-lg lg:text-xl text-center font-normal lg:font-semibold'
            }
          >
            Manage Multiple Beneficiaries
          </h3>
        </div>
        <div
          className={
            'w-1/2 lg:w-1/4 p-4 flex flex-col justify-center items-center'
          }
        >
          <img alt={''} src={OfferImg4} />
          <h3
            className={
              'mt-5 text-gray-800 text-lg lg:text-xl text-center font-normal lg:font-semibold'
            }
          >
            Trusted Payment System
          </h3>
        </div>
      </div>
    </div>
  );
}
